export var RenderSectionType;
(function (RenderSectionType) {
    RenderSectionType[RenderSectionType["Fold"] = 0] = "Fold";
    RenderSectionType[RenderSectionType["Stories"] = 1] = "Stories";
    RenderSectionType[RenderSectionType["LotteriesCarousel"] = 2] = "LotteriesCarousel";
    RenderSectionType[RenderSectionType["Banners"] = 3] = "Banners";
    RenderSectionType[RenderSectionType["LotteriesGrid"] = 4] = "LotteriesGrid";
    RenderSectionType[RenderSectionType["Bundles"] = 5] = "Bundles";
    RenderSectionType[RenderSectionType["InstantGames"] = 6] = "InstantGames";
    RenderSectionType[RenderSectionType["LatestResults"] = 7] = "LatestResults";
    RenderSectionType[RenderSectionType["HowToPlay"] = 8] = "HowToPlay";
    RenderSectionType[RenderSectionType["Advert"] = 9] = "Advert";
    RenderSectionType[RenderSectionType["ScratchCardsCarousel"] = 10] = "ScratchCardsCarousel";
    RenderSectionType[RenderSectionType["InstantGameCards"] = 11] = "InstantGameCards";
    RenderSectionType[RenderSectionType["Row"] = 12] = "Row";
    RenderSectionType[RenderSectionType["LotteriesCart"] = 13] = "LotteriesCart";
    RenderSectionType[RenderSectionType["HottestLotteries"] = 14] = "HottestLotteries";
    RenderSectionType[RenderSectionType["LotteriesResults"] = 15] = "LotteriesResults";
    RenderSectionType[RenderSectionType["LotteriesPurchases"] = 16] = "LotteriesPurchases";
    RenderSectionType[RenderSectionType["BundleDetails"] = 17] = "BundleDetails";
    RenderSectionType[RenderSectionType["BundleGameInformation"] = 18] = "BundleGameInformation";
    RenderSectionType[RenderSectionType["SyndicateLotteriesCarousel"] = 19] = "SyndicateLotteriesCarousel";
    RenderSectionType[RenderSectionType["SyndicateBanner"] = 20] = "SyndicateBanner";
    RenderSectionType[RenderSectionType["SyndicatesCarousel"] = 21] = "SyndicatesCarousel";
    RenderSectionType[RenderSectionType["SyndicateDetails"] = 22] = "SyndicateDetails";
    RenderSectionType[RenderSectionType["LotteryLotteriesCarousel"] = 23] = "LotteryLotteriesCarousel";
    RenderSectionType[RenderSectionType["LotterySwitchPages"] = 24] = "LotterySwitchPages";
    RenderSectionType[RenderSectionType["LotterySubscriptionBanner"] = 25] = "LotterySubscriptionBanner";
    RenderSectionType[RenderSectionType["LotteryChooseTickets"] = 26] = "LotteryChooseTickets";
    RenderSectionType[RenderSectionType["LotteryGameInformation"] = 27] = "LotteryGameInformation";
    RenderSectionType[RenderSectionType["LotteryBanner"] = 28] = "LotteryBanner";
    RenderSectionType[RenderSectionType["LotteryPrizeBreakdown"] = 29] = "LotteryPrizeBreakdown";
    RenderSectionType[RenderSectionType["LotteriesList"] = 30] = "LotteriesList";
    RenderSectionType[RenderSectionType["BundlesList"] = 31] = "BundlesList";
})(RenderSectionType || (RenderSectionType = {}));
export var RenderPageType;
(function (RenderPageType) {
    RenderPageType[RenderPageType["Lobby"] = 0] = "Lobby";
    RenderPageType[RenderPageType["Lottery"] = 1] = "Lottery";
    RenderPageType[RenderPageType["Cart"] = 2] = "Cart";
    RenderPageType[RenderPageType["Results"] = 3] = "Results";
    RenderPageType[RenderPageType["Purchases"] = 4] = "Purchases";
    RenderPageType[RenderPageType["Bundle"] = 5] = "Bundle";
    RenderPageType[RenderPageType["Syndicate"] = 6] = "Syndicate";
    RenderPageType[RenderPageType["Lotteries"] = 7] = "Lotteries";
    RenderPageType[RenderPageType["Bundles"] = 8] = "Bundles";
})(RenderPageType || (RenderPageType = {}));
